import styled from 'styled-components';

export const DirectoryMenuContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: 992px) {
    height: 230px;
    overflow-x: hidden;
    overflow-y: auto;
    position:relative;
  }
  
`;
export const BubbleWrap =styled.div`
// height: 466px;
overflow-x: hidden;
overflow-x: auto;
position:relative;

  @media (max-width: 992px) {
    // height: 296px;

    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
        width:100%;
        padding-inline:13px;
    
  }
`;
export const  LoaderWrap=styled.div`
display:flex;
`;

export const Outer = styled.div`

display: inline-block;


	
	
`;
export const MenuItemContainer = styled.div`
	// height: ;
	// min-width: 30%;
	// overflow: hidden;
	flex: 1 1 auto;
	display: flex;
   // display: inline-block;

	align-items: center;
	justify-content: center;
    background-color:white
	
	margin: 0 7.5px 15px;
	//overflow: hidden;
	&:hover {
        background-color:black
		cursor: pointer;
	
		& .content {
			opacity: 0.9;
		}
	}

  
`;



export const ContentContainer = styled.div`

  padding: 0 25px;
  margin-bottom:30px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  background-color: #222222;
  opacity: 0.7;
  &:hover {
    background-color:black
    cursor: pointer;

    & .content {
        opacity: 0.9;
    }
}
 
`;
export const BackgroundImageContainer = styled.div`
  //width: 100%;
  height: 100%;
  border-radius:10px;
backgroung-color:black;
  background-size: cover;
  background-position: center;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
`;

export const ContentTitle = styled.span`
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 18px;
  color: #ffffff;
`;

export const ContentSubtitle = styled.span`
  font-weight: lighter;
  font-size: 16px;
`;
export const Horiz = styled.div`
flex:1
`;